import React from 'react';
import { Card, withStyles, } from '@material-ui/core';
import axios from '../../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
import { styles } from '../InfoStyles';

export class InfoPrecipitation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 1
        };
    };

    componentDidMount() {
        axios.get('api/map/language')
            .then(res => {
                let response = res.data.data[0].id_jezik;
                if (response) this.setState({ language: response });
            })
            .catch(err => { console.log(err) })
    };

    render() {
        const { classes } = this.props;
        return (
            <div>
                {this.state.language === 1 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Vlažnost lišća je meteorološki parametar koji opisuje količinu rose i padavina preostalih na biljnim površinama a prvenstveno na listu. Koristi se za praćenje vlažnosti lišća čija vrednost značajno utiče na pojavu biljnih bolesti i bitan je podatak za kontrolisano navodnjavanje.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 2 &&
                    <Card className={classes.margin}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Leaf wetness is a meteorological parameter that describes the amount of dew and precipitation remaining on plant, primarily on the leaf. Leaf wetness significantly affects the occurrence of plant diseases and it is important information for controlled irrigation.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 4 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Vlažnost lista je meteorološki parametar koji opisuje količinu rose i oborina koja ostaje na biljci, prvenstveno na listu. Vlažnost lista značajno utječe na pojavu biljnih bolesti i važna je informacija za kontrolirano navodnjavanje.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 5 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Vlažnost listov je meteorološki parameter, ki opisuje količino rose in padavin, ki ostanejo na rastlini, predvsem na listu. Vlažnost listov pomembno vpliva na pojav rastlinskih bolezni in je pomemben podatek za nadzorovano namakanje.
                            </p>
                        </div>
                    </Card>
                }
            </div>
        )
    };
};

export default withStyles(styles)(InfoPrecipitation);